// import { DownloadOptions, Status } from ".";
import { FocusSDK } from "@/utils";
import { message } from "antd";
import BatchDownloadController from "../BatchDownloadController";
import { BatchDownloadItem, ErrorCode, Status, StatusErrorDesc } from "../type";

const retryFn = (Service: BatchDownloadController, item: BatchDownloadItem, index: number) => {
  const isNetWorkOnline = Service.getNetworkStatus();
  if (item.status === ErrorCode.FILE_EXPIRED) {
    message.error(StatusErrorDesc.FILE_EXPIRED);
  } else if (item.status === ErrorCode.PRIVATENET_EGOV_FILE) {
    message.error(StatusErrorDesc.PRIVATENET_EGOV_FILE);
  } else {
    Service.changeTask({
      ...item,
      status: isNetWorkOnline ? Status.WAITING : ErrorCode.NETWORK_ERROR,
      index
    });
    console.log("重试==>", Service.getTaskQueue(), Service.getWorking());
    !Service.getWorking() && isNetWorkOnline && Service.startTask();
  }
  // console.log(isNetWorkOnline,'isNetWorkOnlineisNetWorkOnlineisNetWorkOnline')
};

const pauseFn = (Service: BatchDownloadController, item: BatchDownloadItem, index: number) => {
  const isNetWorkOnline = Service.getNetworkStatus();
  (item as any).cancel && (item as any).cancel();
  console.log(item, "itemitemitemitem===>");
  Service.changeTask({
    ...item,
    status: isNetWorkOnline ? Status.CANCEL : ErrorCode.NETWORK_ERROR,
    currentProgress: 0,
    currentSize: "0"
  });
  console.log("暂停==>", Service.getTaskQueue(), Service.getWorking());
};

const btnAction = {
  [Status.CANCEL]: (Service: any, item: BatchDownloadItem, index: number) => {
    pauseFn(Service, item, index);
  },
  [Status.RETRY]: (Service: any, item: BatchDownloadItem, index: number) => {
    retryFn(Service, item, index);
  },
  [Status.ERROR]: (Service: any, item: BatchDownloadItem, index: number) => {
    retryFn(Service, item, index);
  },
  [Status.SUCCESS]: async (Service: any, item: BatchDownloadItem, index: number) => {
    const isExist = await Service.checkLocalPathExist(item.path);
    console.warn(isExist, "isExist===> 路径", item.path);
    isExist ? FocusSDK.openItem(item.path) : message.error(StatusErrorDesc.PATH_NOT_EXIST);
  },
  [Status.PROGRESS]: (Service: any, item: BatchDownloadItem, index: number) => {
    pauseFn(Service, item, index);
  },
  [Status.WAITING]: (Service: any, item: BatchDownloadItem, index: number) => {
    pauseFn(Service, item, index);
  }
};

export { btnAction };
